import { Injectable } from '@angular/core';

import { SessionStorageService } from '../../../../core/services/web-storage';
import { CampanhaFilter } from './campanha-filter';
import { CampanhaFilterStorage } from './campanha-filter-storage';

/**
 * Service utilizado para armazenar os dados do filter das campanhas no session storage do navegador
 */
@Injectable({
    providedIn: 'root'
})
export class CampanhaFilterStorageService {

    constructor(private sessionStorageService: SessionStorageService) { }

    /** Obtem os dados do filtro armazenados */
    get(storageKey: string): CampanhaFilterStorage {
        const data = this.sessionStorageService.getObject(storageKey) as CampanhaFilterStorage;
        if (data) {
            // Criando um Map com os campos filtrados e seus respectivos valores
            data.filterValues = new Map();
            const keys = Object.keys(data.filter);
            keys.forEach(key => data.filterValues.set(key, data.filter[key]));
        }

        return data;
    }

    /** Armazena os dados do filtro */
    set(storageKey: string, filter: CampanhaFilter) {
        const data = new CampanhaFilterStorage(filter);
        this.sessionStorageService.setObject(storageKey, data);
    }

    /** Remove os dados do filtro */
    remove(storageKey: string) {
        this.sessionStorageService.remove(storageKey);
    }

    /** Verifica se possui filtro salvo no storage */
    hasFilter(storageKey: string): boolean {
        const filter = this.get(storageKey);
        return filter != null && filter !== undefined;
    }

    /** Aplica o filtro armazenado no objeto do filtro informado */
    applyFilter(storageKey: string, filter: CampanhaFilter) {
        const filterStorage = this.get(storageKey);
        if (filterStorage != null) {
            // Se possuir os dados, então setamos o filtro com os seus valores armazenados
            if (filter) {
                filterStorage.filterValues.forEach((value, key) => filter[key] = value);
            }
        }
    }
}
